export const DetailsToggle = () => {
    const sections = document.querySelectorAll('.read-more-section');

    if (sections.length > 0) {
        sections.forEach(section => {
            section.querySelector('.read-more-section__toggle').addEventListener('click', (e) => {
                const btnText = e.currentTarget.querySelector('span');
                if (btnText.textContent === 'Czytaj więcej') {
                    btnText.textContent = 'Czytaj mniej';
                } else {
                    btnText.textContent = 'Czytaj więcej';
                }
                section.classList.toggle('read-more-section--opened');
            })
        });
    }

    const productDetailsOpen = document.querySelector('.productDetailsOpen');
    const productDetails = document.querySelector('.productDetails');

    if (productDetails !== null && productDetailsOpen !== null) {
        productDetailsOpen.addEventListener('click', (e) => {
            const btnAriaText = e.currentTarget.getAttribute('aria-label');
            const isExpanded = e.currentTarget.getAttribute("aria-expanded") === "true";
            const icon = e.currentTarget.querySelector('svg');

            if (btnAriaText === 'Rozwiń szczegóły') {
                e.currentTarget.setAttribute("aria-label", "Zwiń szczegóły");
            } else {
                e.currentTarget.setAttribute("aria-label", "Rozwiń szczegóły");
            }

            e.currentTarget.setAttribute("aria-expanded", !isExpanded);
            e.currentTarget.classList.toggle('rounded-b-md');
            productDetails.classList.toggle('hidden');
            icon.classList.toggle('rotate-180');

        });
    }
}